<template>
  <el-button
      :type="type"
      :icon="icon"
      @click="handleBack"
      :size="size"
      v-bind="$attrs"
  >
    <slot style="color: #fff">{{ text }}</slot>
  </el-button>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    icon: {
      type: String,
      default: 'el-icon-back'
    },
    size: {
      type: String,
      default: 'medium'
    },
    text: {
      type: String,
      default: '返回'
    },
    fallbackPath: {
      type: String,
      default: '/scan' // 默认兜底路径
    }
  },
  methods: {
    handleBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push(this.fallbackPath);
      }
      // 触发自定义事件（可选）
      this.$emit('back');
    }
  }
}
</script>

<style scoped>
   ::v-deep .el-button--text{
     color: #fff;
   }
</style>